/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskUser } from '@/task-manager/entities/task-user';

import {
  type ListAllUsersViewOutput as Data,
  usersV1ListRetrieve,
} from '../fetch-client';
import { taskUserMapper } from '../mappers/task-user';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ListUsers {
  export const key = () => ['task-manager', 'list-users'];

  export type Output = {
    users: TaskUser[];
  };
  export type QueryParams = {};
  function outputFromBody(data: Data): Output {
    return {
      users: data.users.map(taskUserMapper),
    };
  }

  export function useQuery() {
    const getOpts = useFetchOpts();

    return rq.useQuery<Output>({
      queryKey: key(),
      async queryFn({ signal }) {
        const opts = await getOpts();
        const data = await ok(
          usersV1ListRetrieve(
            {},
            {
              ...opts,
              signal,
            },
          ),
        );
        return outputFromBody(data);
      },
    });
  }
}
